module.exports = __webpack_public_path__ + "img/desktop_person1.7451d5b2.svg";